import { useRef } from "react";

/**
 * Radix returns focus on close only to a `*Trigger`; our dialogs and sheets often open from a
 * plain button. This remembers what had focus as the content opens and returns there on close,
 * unless the caller's own `onCloseAutoFocus` already handled it.
 */
export function useReturnFocus(handlers: {
  onOpenAutoFocus?: ((event: Event) => void) | undefined;
  onCloseAutoFocus?: ((event: Event) => void) | undefined;
}) {
  const opener = useRef<HTMLElement | null>(null);
  return {
    // Runs before Radix moves focus inside: the opener still has it.
    onOpenAutoFocus: (event: Event) => {
      opener.current = document.activeElement as HTMLElement | null;
      handlers.onOpenAutoFocus?.(event);
    },
    onCloseAutoFocus: (event: Event) => {
      handlers.onCloseAutoFocus?.(event);
      if (event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      const target = opener.current;
      opener.current = null;
      if (target?.isConnected && target !== document.body) {
        target.focus();
      }
    },
  };
}
